import {FC, useState} from 'react'
import {getSubmissions} from "../../wordpress/operations/get-submissions";
import {useNavigate} from "react-router-dom";
import {bookingFlows} from "../../constants/global";
import {getNextStep, isStepFulfilled, isStepOptionsFulfilled, storeBooking} from "../../lib/booking";
import ScrollTo from "../common/ScrollTop/ScrollTo";
import findMenuItem from "../../lib/find-menu-item";
import Content from "../main/Content";
import {updateBooking} from "../../wordpress/operations/post-booking-update";
import {getSimulatedBookingFlow} from "../../lib/helpers";
import ExtraFields from "../Options/ExtraFields";

interface Props {
    booking: Booking
    setBooking: Function,
    content:Content
}

const Submission: FC<Props> = ({ booking, setBooking, content }) => {

    const [options, setOptions] = useState<any>(null);
    const navigate = useNavigate();
    const bookingFlow = bookingFlows[booking.booking_flow]
    const simulatedBookingFlow = getSimulatedBookingFlow(booking.booking_flow);
    const activeStep = bookingFlow.step
    const next = getNextStep(bookingFlow.menu, activeStep)
    const stepFullFilled = isStepFulfilled(activeStep, booking)

    if(!options) {
        getSubmissions(booking).then((val) => {
            setOptions(val)

            console.log(val)
            // Remove selected choice if not available
            let reset = true
            for(let i=0; i<val.length; i++) {
                if(booking.submission.slug === val[i].slug)
                    reset = false;

                if(booking.submission.slug === booking.booking_flow)
                    reset = false
            }
            booking.submission.slug = reset ? '' : booking.submission.slug

            booking.submission.reload = false
            setBooking({
                ...booking,
            })
        })
        return
    }

    if(booking.submission.reload) {
        setOptions(null)
    }

    if(!booking.date || (booking.service.booking_flow==='window' && booking.window.form.window_damage_type === 'chip')) {
        return
    }

    if((simulatedBookingFlow==='hjulskifte') && !booking.submission.time) {
        return
    }

    if(options.length === 1 && booking.submission.time) {
        // When a time is selected "Vänta på plats" is mandatory
        return
    }

    const handleClick = (option:any) => {
        let type = []
        const simulatedBookingFlow = getSimulatedBookingFlow(booking.booking_flow);

        if(option.show_on_extra.includes("show_address")) {
            type.push('address')
        }

        if(option.show_on_extra.includes("show_extra_alt")) {
            type.push('time')
        }

        if(option.show_on_extra.includes("nio_only")) {
            type.push('time')
        }

        if(simulatedBookingFlow === 'hjulskifte') {
            type.push('time')
        }

        booking.submission.name = option.namn
        booking.submission.slug = option.slug
        booking.submission.type = type

        if(simulatedBookingFlow!='hjulskifte') {
            booking.submission.time = ''
        }

        booking.submission.address = ''
        booking.submission.city = ''
        booking.submission.postal = ''


        const item = findMenuItem(next, content)
        booking.page = item.slug

        setBooking({
            ...booking,
        })


        if (activeStep === 'date' && booking.hjulskifte_update) {
            if(!isStepOptionsFulfilled(booking, true, setBooking)) {
              return
            }

            booking.order_loading = true
            storeBooking(booking, setBooking)
            updateBooking(booking).then((val) => {
                booking.order_loading = false

                storeBooking(booking, setBooking)
                if (val.status === 'success') {
                    if (val.redirect) {
                        window.location.replace(val.redirect);
                    } else {
                        navigate('/tack-for-din-bokning') // Navigate order summary
                    }
                    return
                } else {
                    // Error
                    booking.order_loading = false
                    storeBooking(booking, setBooking)
                }
            })
        }else{
            navigate('/' + item.slug)
        }
    }

    if(options.length === 0)
        return

    return (
        <>
            <div className={'submissions active'}>
                <h2 className="required">Inlämningsalternativ</h2>
                {options.map((option:any, i:number) => (
                    <div key={i} onClick={() => handleClick(option)} className={`submissions_option ${booking.submission.slug === option.slug ? "active" : ""}`}>
                        <h4>{option.namn}</h4>
                        <p>{option.beskrivning}</p>
                    </div>
                ))}
                {  booking.submission.type.includes("address") && (
                    <ExtraFields booking={booking} setBooking={setBooking}/>
                )}
                <ScrollTo title={''}/>
            </div>

        </>
    )
};

export default Submission
